import React, { Component } from "react";
import "./App.css";
import Page from "./containers/Page/Page";
import Header from "./components/Header/Header";
import WelcomeModal from "./components/WelcomeModal/WelcomeModal";
import ChooseModelModal from "./components/ChooseModelModal/ChooseModelModal";
import WelcomePage from "./containers/WelcomePage/WelcomePage";
import { getPathToTypeList } from "./utils/listBodyUtils";
import { defaultTemplateName } from "./config/defaults";
import Navbar from "./containers/Navbar/Navbar";
import Sidebar from "./containers/Sidebar/Sidebar";
import MobileNotAvailableWarning from "./components/MobileNotAvailableWarning/MobileNotAvailableWarning";
import {
  setLanguage,
  getTranslation,
  getCurrentLang,
} from "./assets/creator/translations";
import { elementTypes } from "./assets/elements.json";
import MainLayoutContainer from "./containers/MainLayoutContainer/MainLayoutContainer";
import { getIsFirstVisit, getIsWelcomeModal } from "./utils/welcomePageUtils";

class App extends Component {
  initialAppState = () => ({    
    templateName: defaultTemplateName,
    lang: getCurrentLang(),
    isWelcomeModalOpen: getIsWelcomeModal(),
    firstVisit: getIsFirstVisit(),
    isChooseModelModalOpen: false,
    editedTemplate: false,
  });

  constructor(props) {
    super(props);
    this.state = {
      ...this.initialAppState(),
      //on app start, get the language
      lang: getCurrentLang(),
      loading: false
    };
    this.pathToTypeList = getPathToTypeList();
    this.sidebarRef = React.createRef();
    this.navbarRef = React.createRef();
    document.title = getTranslation("PageTitle");
  }

  onLangChange = (newLang) => {
    setLanguage(newLang);
    document.title = getTranslation("PageTitle");
    this.setState({ lang: newLang });
  };

  Navbar = () => (
    <Navbar />
  );

  Sidebar = () => (
    <Sidebar
      ref={this.sidebarRef}
      getSidebarTemplateMenu={this.getSidebarTemplateMenu}
      getSideBarFooter={this.getSideBarFooter}
      onLangChange={this.onLangChange}
      currentLang={this.state.lang}
    />
  );

  setTemplateName = (name) => {
    if (!name) name = defaultTemplateName;

    this.setState({ templateName: name });
    return true;
  };

  getElement = (listName, i) => this.state[listName][i];

  handleShowWelcomeModal = isShow => this.setState({ isWelcomeModalOpen: isShow });

  handleShowChooseModelModal = isShow => this.setState({ isChooseModelModalOpen: isShow });

  handleEditedTemplate = edited => this.setState({ editedTemplate: edited });

  get pageCommonProps() {
    return {
      pageHeader: <this.Header />,
      getElement: this.getElement,
      navbar: <this.Navbar />,
      navbarRef: this.navbarRef,
      sidebar: <this.Sidebar />,
      sidebarRef: this.sidebarRef
    };
  }

  //returns all possible routes
  getPages = () =>
    this.state.firstVisit ?
    (<WelcomePage
      show={this.state.isWelcomeModalOpen}
      lang={this.state.lang}
      onLangChange={this.onLangChange}
      notFirstVisit={!this.state.firstVisit}
    />) :
    (this.pathToTypeList.map((page, index) => (
        <Page
        pageType={page.type}
        key={page.listName}
        bodyListName={page.listName}
        body={this.state[page.listName]}
        elementTypes={elementTypes[page.type]}
        {...this.pageCommonProps}
      />
    )))

  getModals = () => (
    <React.Fragment>
      <WelcomeModal
        show={this.state.isWelcomeModalOpen}
        handleIsShowWelcomeModal={this.handleShowWelcomeModal}
        handleIsShowChooseModelModal={this.handleShowChooseModelModal}
        handleIsEditedTemplate={this.handleEditedTemplate}
      />

      <ChooseModelModal
        show={this.state.isChooseModelModalOpen}
        isEditedTemplate={this.state.editedTemplate}
        lang={this.state.lang}
        handleIsShowWelcomeModal={this.handleShowWelcomeModal}
        handleIsShowChooseModelModal={this.handleShowChooseModelModal}
        handleIsEditedTemplate={this.handleEditedTemplate}
      />
    </React.Fragment>
  );

  Header = () => (
    <Header
      ref={this.HeaderRef}
      templateName={this.state.templateName}
    />
  );

  MainLayoutContainer = () => (
    <MainLayoutContainer />
  );

  iframeMessageListener = (e) => {
    this.setState({ loading: false, iframeOrigin: e.origin });
    if (!e.data.haveXml) return;
  };

  componentDidMount = () => {
    window.addEventListener("message", this.iframeMessageListener, false);
    if (!this.props.isInIframe) return;

    window.addEventListener("message", this.iframeMessageListener, false);
    setTimeout(() => window.parent.postMessage("Creator_RDY", "*"), 1000);
  };


  readyRender = () => (
    //router displays proper pages depending on url
    <React.Fragment>
      <MobileNotAvailableWarning
        lang={this.state.lang}
        langChangeHandler={this.onLangChange}
      />
      <div className="container">
        {this.iframeRender()}
        {this.getPages() /*add all possible routes*/}
      </div>
    </React.Fragment>
  );

  iframeRender = () =>
    this.state.loading ? (
      <div>Loading...</div>
    ) : this.state.timeoutError ? (
      <div>Error, comm timeout</div>
    ) : this.state.invalidOrigin ? (
      <div>Error, invalid message origin</div>
    ) : (
      this.getModals()
    );

  render() {
    //this shouldn't be called here (mutates the object before rendering)
    return this.readyRender();
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js